var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "TopNav" }, [
    _c(
      "div",
      { staticClass: "let" },
      [
        _c(
          "el-menu",
          {
            staticClass: "el-menu-demo",
            attrs: {
              "default-active": _vm.activeIndex,
              mode: "horizontal",
              "background-color": _vm.variables.menuBg,
            },
            on: { select: _vm.handleSelectTo },
          },
          _vm._l(_vm.allRouter, function (v, i) {
            return _c(
              "el-menu-item",
              { key: v.id, attrs: { index: "" + v.id } },
              [_vm._v(_vm._s(v.name))]
            )
          }),
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _vm.activeIndex == 3
      ? _c("div", { staticClass: "right" }, [
          _c(
            "section",
            { staticClass: "title", on: { click: _vm.changeProject } },
            [
              _c(
                "span",
                {
                  staticStyle: {
                    "min-width": "100px",
                    "max-width": "300px",
                    "padding-right": "5px",
                  },
                },
                [
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        content: _vm.defaultProject.project.project_name,
                        placement: "bottom",
                      },
                    },
                    [
                      _c("span", [
                        _vm._v(
                          " " + _vm._s(_vm.defaultProject.project.project_name)
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "span",
                { staticStyle: { "min-width": "100px", "max-width": "150px" } },
                [
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        content:
                          _vm.defaultProject.centerInvid +
                          _vm.defaultProject.center.center,
                        placement: "bottom",
                      },
                    },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.defaultProject.centerInvid +
                              _vm.defaultProject.center.center
                          )
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "span",
                { staticStyle: { "min-width": "60px", "max-width": "100px" } },
                [
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        content: "{" + _vm.defaultProject.roleName + "}",
                        placement: "bottom",
                      },
                    },
                    [
                      _c("span", [
                        _vm._v(_vm._s("{" + _vm.defaultProject.roleName + "}")),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "span",
                { staticStyle: { width: "70px" } },
                [
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        content:
                          _vm.defaultProject.env == "dev" ? "{测试}" : "{正式}",
                        placement: "bottom",
                      },
                    },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.defaultProject.env == "dev"
                              ? "{测试}"
                              : "{正式}"
                          )
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("i", { staticClass: "el-icon-arrow-down" }),
            ]
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }